// extracted by mini-css-extract-plugin
export default {"action-container":"article-editor_action-container__8v20R","action-container__message":"article-editor_action-container__message__p8GEY"};